import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useAuth } from "@/hooks/use-auth";
import { useEditProfile } from "@/hooks/use-edit-profile";

const BankDetails = forwardRef((props, ref) => {
  const { astrologer } = useAuth();
  const { handleBankUpdate, loading } = useEditProfile();
  const [bankData, setBankData] = useState({
    firstName: "",
    bankName: "",
    bankAccountNumber: "",
    ifscCode: "",
    upi: "",
  });

  useEffect(() => {
    if (astrologer.paymentDetails) {
      setBankData({
        firstName: astrologer.paymentDetails.firstName || "",
        bankName: astrologer.paymentDetails.bankName || "",
        bankAccountNumber: astrologer.paymentDetails.bankAccountNumber || "",
        ifscCode: astrologer.paymentDetails.ifscCode || "",
        upi: astrologer.paymentDetails.upi || "",
      });
    }
  }, [astrologer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBankData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Method to submit the form - exposed to parent via ref
  const submitForm = async () => {
    try {
      await handleBankUpdate(bankData);
      return true;
    } catch (error) {
      console.error("Error updating bank details:", error);
      return false;
    }
  };

  // Expose methods to parent component
  useImperativeHandle(ref, () => ({
    submitForm
  }));

  return (
    <div className="w-full">
      <h1 className="text-2xl font-bold mb-6">Bank Details</h1>

      <div className="flex flex-col gap-6">
        {/* Name Field */}
        <div className="flex flex-col">
          <label className="mb-2 text-gray-700">
            Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="firstName"
            value={bankData.firstName}
            onChange={handleInputChange}
            placeholder="Entre your Name"
            className="border border-gray-300 rounded-lg p-3 w-full"
            required
          />
        </div>

        {/* Bank Name Field */}
        <div className="flex flex-col">
          <label className="mb-2 text-gray-700">
            Bank Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="bankName"
            value={bankData.bankName}
            onChange={handleInputChange}
            placeholder="Entre your Bank Name"
            className="border border-gray-300 rounded-lg p-3 w-full"
            required
          />
        </div>

        {/* Account Number and IFSC Code - Row */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex flex-col flex-1">
            <label className="mb-2 text-gray-700">
              Account Number <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="bankAccountNumber"
              value={bankData.bankAccountNumber}
              onChange={handleInputChange}
              placeholder="+91"
              className="border border-gray-300 rounded-lg p-3 w-full"
              required
            />
          </div>

          <div className="flex flex-col flex-1">
            <label className="mb-2 text-gray-700">
              IFSC Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="ifscCode"
              value={bankData.ifscCode}
              onChange={handleInputChange}
              placeholder="akshay@gmail.com"
              className="border border-gray-300 rounded-lg p-3 w-full"
              required
            />
          </div>
        </div>

        {/* UPI ID Field */}
        <div className="flex flex-col">
          <label className="mb-2 text-gray-700">
            UPI id <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="upi"
            value={bankData.upi}
            onChange={handleInputChange}
            placeholder="Add UPI id"
            className="border border-gray-300 rounded-lg p-3 w-full"
            required
          />
        </div>
      </div>
    </div>
  );
});

BankDetails.displayName = "BankDetails";
export default BankDetails;